import { render, staticRenderFns } from "./GalleryMovePhotosDlg.vue?vue&type=template&id=45bb9f1a&scoped=true"
import script from "./GalleryMovePhotosDlg.ts?vue&type=script&lang=ts&external"
export * from "./GalleryMovePhotosDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./GalleryMovePhotosDlg.vue?vue&type=style&index=0&id=45bb9f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb9f1a",
  null
  
)

export default component.exports